import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import {
	getGeneralFilteredAssets,
	getSelectedOrganization
} from 'helpers/selectors';

const getSelectedEvent = ({ eventLog }) => {
	return eventLog.selectedEvent;
};

const getSelectedAsset = ({ powertrainAssetDetails }) => {
	return powertrainAssetDetails.selectedAsset;
};

const getIsExpanded = ({ eventLog }) => {
	return eventLog.isExpanded;
};

const getNewCapabilityLoadingStatus = ({ powertrainAssetDetails }) => {
	return powertrainAssetDetails.newAssetCapability?.loadingStatus;
};

const getEventLogError = ({ eventLog }) => {
	return eventLog.eventLogError;
};

const getEventLogLoadingStatus = ({ eventLog }) => {
	return eventLog.eventLogLoadingStatus;
};

const getCapabilitiesError = ({ eventLog }) => {
	return eventLog.capabilitiesError;
};

const getCapabilitiesLoadingStatus = ({ eventLog }) => {
	return eventLog.capabilitiesLoadingStatus;
};

const getEventLogErrorRaw = (state) => ({
	loadingStatus: getEventLogLoadingStatus(state),
	error: getEventLogError(state),
	errorCode: getEventLogError(state)?.statusCode
});

const getCapabilitiesErrorRaw = (state) => ({
	loadingStatus: getCapabilitiesLoadingStatus(state),
	error: getCapabilitiesError(state),
	errorCode: getCapabilitiesError(state)?.statusCode
});

// Memoized selector for event log loading data
const getEventLogLoadingData = createErrorDataSelector(getEventLogErrorRaw);

// Memoized selector for capabilities loading data
const getCapabilitiesLoadingData = createErrorDataSelector(getCapabilitiesErrorRaw);


export const getModel = createSelector([
	getSelectedEvent,
	getSelectedAsset,
	getSelectedOrganization,
	getGeneralFilteredAssets,
	getIsExpanded,
	getNewCapabilityLoadingStatus,
	getEventLogLoadingData,
	getCapabilitiesLoadingData
], (
	selectedEvent,
	selectedAsset,
	selectedOrganization,
	generalFilteredAssets,
	isExpanded,
	assetCapabilityLoadingStatus,
	eventLogLoadingData,
	capabilitiesLoadingData
) => {
	return {
		selectedEvent,
		selectedAsset,
		selectedOrganization,
		generalFilteredAssets,
		isExpanded,
		assetCapabilityLoadingStatus,
		eventLogLoadingData,
		capabilitiesLoadingData
	};
});


